import React from 'react';
import EngagementStatisticsRouteDropdown from './EngagementStatisticsRouteDropdown';

const EngagementStatisticsDropdown = () => {
  return <EngagementStatisticsRouteDropdown />;
};

export default EngagementStatisticsDropdown;
